import { render, staticRenderFns } from "./RiskyUsersPolicy.vue?vue&type=template&id=7ce1a0de&scoped=true&"
import script from "./RiskyUsersPolicy.vue?vue&type=script&lang=ts&"
export * from "./RiskyUsersPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RiskyUsersPolicy.vue?vue&type=style&index=0&id=7ce1a0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce1a0de",
  null
  
)

export default component.exports